<template>
  <div>
    <ag-grid-vue
      ref="agGridTable"
      class="scroll-to-ag-grid-table-report-list ag-theme-alpine w-100 my-4 ag-grid-table"
      :columnDefs="columns"
      :defaultColDef="defaultColDef"
      :rowData="processList"
      rowSelection="multiple"
      colResizeDefault="shift"
      :animateRows="true"
      :pagination="true"
      @grid-ready="onGridReady"
      :suppressCopyRowsToClipboard="true"
      :localeText="localeText"
      :suppressRowClickSelection="true"
      @first-data-rendered="onFirstDataRendered"
      :gridOptions="gridOptions"
      :chartToolPanelsDef="chartToolPanelsDef"
    >
    </ag-grid-vue>
    <div id="chartContainer" class="ag-theme-quartz"></div>
  </div>
</template>
<script>
import i18nData from "../../i18n/i18nData";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import moment from "moment";
export default {
  components: {
    AgGridVue,
  },
  props: {
    customer: {
      default: () => {},
      required: true,
    },
    reportName: {
      default: () => {},
      required: true,
    },
  },
  data() {
    return {
      gridOptions: {
        enableRangeSelection: true,
        enableCharts: true,
        chartThemes: ["ag-default"],
      },
      chartToolPanelsDef: {
        defaultToolPanel: "settings",
      },
      columns: [],
      processList: [],
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
    };
  },
  methods: {
    runReport() {
      const vs = this.$vs;
      console.log(this.customer);
      let obj = {
        companyId: this.customer.value,
        name: this.reportName.name,
      };
      try {
        this.$store
          .dispatch("report/runReports", obj)
          .then((response) => {
            if (response.success == true) {
              try {
                this.columns = [];
                this.processList = JSON.parse(response.json);
                if (this.processList.length > 0) {
                  let columnList = Object.keys(this.processList[0]);

                  columnList.forEach((val, index) => {
                    if (val == "CompanyName") {
                      this.columns.push({
                        pinned: "left",
                        headerName: this.$t(val),
                        field: val,
                        filter: "agSetColumnFilter",
                      });
                    } else if (val == "CompanyTransType") {
                      this.columns.push({
                        headerName: this.$t(val),
                        field: val,
                        filter: "agSetColumnFilter",
                        cellRendererFramework: "CustomerActListTransferType",
                      });
                    } else if (val.toString().includes("Date") == true)
                      this.columnsProcess.push({
                        headerName: this.$t(val),
                        field: val,
                        filter: "agSetColumnFilter",
                        valueFormatter: (params) => this.parseDate(params.data[val]),
                        editable: true,
                      });
                    else if (
                      val.toString().includes("Id") == false &&
                      val.toString().includes("InfoType") == false
                    )
                      this.columns.push({
                        headerName: this.$t(val),
                        field: val,
                        filter: "agSetColumnFilter",
                      });
                  });
                }
              } catch (error) {
                console.log(error);
              }
            } else {
              console.log(response);
            }
          })
          .catch((error) => {
            return new Promise((resolve, reject) => {
              resolve(false);
            });
          });
      } catch (error) {
        console.log(error);
      }
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      var defaultSortModel = [{ colId: "CompanyName", sort: "asc", sortIndex: 0 }];
      params.columnApi.applyColumnState({ state: defaultSortModel });
      this.gridApi.refreshCells(params);
    },
    onFirstDataRendered(params) {
      params.api.createRangeChart({
        cellRange: {
          rowStartIndex: 0,
          rowEndIndex: 3,
          columns: ["StockCode", "qEntery", "qExit"],
        },
        chartType: "line",
        chartContainer: document.querySelector("#chartContainer"),
        suppressChartRanges: true,
        chartToolPanelsDef: {
          defaultToolPanel: "settings",
        },
      });
      params.api.sizeColumnsToFit();
    },
  },

  watch: {
    customer(val) {
      this.runReport();
      return val;
    },
    reportName(val) {
      this.runReport();

      return val;
    },
  },
  computed: {
    localeText() {
      return i18nData[this.$i18n.locale];
    },
    reportNameLocal: {
      get() {
        return this.reportName;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    customerLocal: {
      get() {
        return this.customer;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
  },
};
</script>
<style lang="scss">
.scroll-to-ag-grid-table-report-list {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 110px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
[dir] .btn-group button {
  padding: 4px !important;
}
.bg-success-item-ag {
  background-color: #f4f9c4 !important;
}

.bg-danger-item-ag {
  background-color: #f8cbcc !important;
}
</style>
